export function OutlinePlaningIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99999 20.9999L6.99838 17.9999H4.99679C3.8928 17.9999 3 17.1071 3 16.0032V4.99679C3 3.8928 3.8928 3 4.99679 3H19.0031C20.1071 3 20.9999 3.8928 20.9999 4.99679V5.99999"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8726 14.2219L17.4084 11.7578L12.4802 16.686L14.9443 19.1502L19.8726 14.2219Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4904 11.1422C21.1692 11.821 21.1692 12.9275 20.4904 13.6063L19.876 14.2207L17.4119 11.7565L18.0262 11.1422C18.7051 10.4634 19.8115 10.4634 20.4904 11.1422Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7134 20.3854L10.6318 20.9998L11.251 17.9182L12.4798 16.6895L14.947 19.1518L13.7134 20.3854Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99854 6.99805L9.00013 8.99964"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99854 8.99964L9.00013 6.99805"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00157 13.9968C8.55297 13.9968 8.99997 13.5498 8.99997 12.9984C8.99997 12.447 8.55297 12 8.00157 12C7.45017 12 7.00317 12.447 7.00317 12.9984C7.00317 13.5498 7.45017 13.9968 8.00157 13.9968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9983 8.00124L14.0015 6.99805L14.9999 8.00124"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00146 12.998H10.1615C12.283 12.998 14.0014 11.2796 14.0014 9.15804V6.99805"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
